import React, {PureComponent} from 'react';
import {showPopup} from 'app/utils/modals/ModalsService';
import SteamTradePopup from 'app/components/my_profile/artifacts/SteamTradePopup';
import SteamTradeInterface from 'app/interfaces/SteamTradeInterface';
import AlertPoint from 'app/components/AlertPoint';
import PrizeCard from 'app/components/reusable/PrizeCard';

interface SteamTradeSlotProps {
    steamTrade: SteamTradeInterface;
}

export const openSteamTradePopup = (steamTrade: SteamTradeInterface): void => {
    const {id, steam_skin, state, will_sold_at} = steamTrade;
    showPopup('inventory-popup',
        (props: {popupId: string}) => <SteamTradePopup
            id={id}
            popupId={props.popupId}
            state={state}
            steam_skin={steam_skin}
            will_sold_at={will_sold_at}
        />);
};

export default class SteamTradeSlot extends PureComponent<SteamTradeSlotProps> {
    openPopup = (): void => {
        openSteamTradePopup(this.props.steamTrade);
    };

    render(): React.ReactNode {
        const {steamTrade: {id, state, steam_skin}} = this.props;

        return <PrizeCard
            artifact={steam_skin}
            extra={state === 'pending_edits' ? <AlertPoint/> : null}
            hideMeta
            hideName
            id={`steam-trade-hero-slot-${id}`}
            onClick={this.openPopup}
            unavailable={state === 'on_approval'}
        />;
    }
}
